// extracted by mini-css-extract-plugin
export default {"paragraph":"MmcFieldInfoModal_paragraph__AMBsb","middleText":"MmcFieldInfoModal_middleText__dokaU","image":"MmcFieldInfoModal_image__PVPIj"};